import React from 'react'
import { useState, useEffect } from 'react'
import {
  FooterSection,
  InputWithButton2,
  ListSearch,
  PaginationSearch,
} from '@components'
import { BannerSearchBackground } from '../../assets/images'
import { Search as IconSearch } from '../../common/icons'
import { useTranslation } from 'react-i18next'
import './Search.scss'
import { GlobalSearchingAPI } from '@api'
import { useQuery } from '@hooks'

const Search = () => {
  const { t } = useTranslation()
  const [data, setdata] = useState({})
  const [total, setTotal] = useState('')
  const [isLoading, setisLoading] = useState(true)
  const query = useQuery()
  const page = query.get('page') || 1
  const [search, setSearch] = useState(query.get('q') || '')
  const [isSearch, setIsSearch] = useState(false)
  const [staticSearch, setStaticSearch] = useState('')

  useEffect(() => {}, [isSearch])

  const dateCreation = new Date('2023-09-15 00:00:01')
  const dataSearch = [
    {
      date: dateCreation,
      desc: 'Ketahui perjalanan dan riwayat singkat KB Bank dari berdiri sejak 1970 hingga kini',
      id: 0,
      object: 'TentangKami-riwayat',
      object_title: 'Tentang Kami',
      title: 'Riwayat Kami',
    },
    {
      date: dateCreation,
      desc: 'visi & misi bank kbbukopin',
      id: 1,
      object: 'TentangKami-visiMisi',
      object_title: 'Profil Bank',
      title: 'Visi & Misi',
    },
    {
      date: dateCreation,
      desc: 'KB Bank menjalankan kegiatan usaha berupa penghimpunan dana dan penyaluran kredit yang fokus pada empat pilar utama yaitu bisnis Mikro, Usaha Kecil dan Menengah (UKM), Bisnis Konsumer serta Bisnis Komersial.',
      id: 2,
      object: 'TentangKami-segmenBisnis',
      object_title: 'Profil Bank',
      title: 'Segmen Bisnis',
    },
    {
      date: dateCreation,
      desc: 'KB Bank memiliki dua anak perusahaan yang bergerak pada bidang pembiayaan sewa dan juga syariah',
      id: 3,
      object: 'TentangKami-anakPerusahaan',
      object_title: 'Profil Bank',
      title: 'Anak Perusahaan',
    },
    {
      date: dateCreation,
      desc: 'KB Bank menjunjung tinggi nilai-nilai budaya perusahaan yang diterapkan dalam operasional internal maupun layanan kepada nasabah',
      id: 4,
      object: 'TentangKami-budayaPerusahaan',
      object_title: 'Profil Bank',
      title: 'Budaya Perusahaan',
    },
    {
      date: dateCreation,
      desc: 'Pencapaian penghargaan KB Bank menjadikan semangat kami untuk terus menjadi #BintangFinansial',
      id: 5,
      object: 'TentangKami-penghargaan',
      object_title: 'Profil Bank',
      title: 'Penghargaan',
    },
    {
      date: dateCreation,
      desc: 'bank koresponden',
      id: 6,
      object: 'TentangKami-bankKoresponden',
      object_title: 'Profil Bank',
      title: 'Bank Koresponden',
    },
    {
      date: dateCreation,
      desc: 'lembaga profesi perusahaan',
      id: 7,
      object: 'TentangKami-lembagaProfesi',
      object_title: 'Profil Bank',
      title: 'Lembaga Profesi',
    },
    {
      date: dateCreation,
      desc: 'hubungi kami',
      id: 8,
      object: 'TentangKami-hubungiKami',
      object_title: 'Profil Bank',
      title: 'Hubungi Kami',
    },
    {
      date: dateCreation,
      desc: 'piagam',
      id: 9,
      object: 'TataKelolaPerusahaan-piagam',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Piagam',
    },
    {
      date: dateCreation,
      desc: 'pedoman',
      id: 10,
      object: 'TataKelolaPerusahaan-pedoman',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Pedoman',
    },
    {
      date: dateCreation,
      desc: 'laporan tata kelola',
      id: 11,
      object: 'TataKelolaPerusahaan-laporanTataKelola',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Laporan Tata Kelola',
    },
    {
      date: dateCreation,
      desc: 'kode etik',
      id: 12,
      object: 'TataKelolaPerusahaan-kodeEtik',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Kode Etik',
    },
    {
      date: dateCreation,
      desc: 'whistleblowing system',
      id: 13,
      object: 'TataKelolaPerusahaan-whistleblowingSystem',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Whistleblowing System',
    },
    {
      date: dateCreation,
      desc: 'dewan komisaris',
      id: 14,
      object: 'StrukturManajemen-dewanKomisaris',
      object_title: 'Struktur Manajemen',
      title: 'Dewan Komisaris',
    },
    {
      date: dateCreation,
      desc: 'dewan direksi',
      id: 15,
      object: 'StrukturManajemen-dewanDireksi',
      object_title: 'Struktur Manajemen',
      title: 'Dewan Direksi',
    },
    {
      date: dateCreation,
      desc: 'komite',
      id: 16,
      object: 'StrukturManajemen-komite',
      object_title: 'Struktur Manajemen',
      title: 'Komite',
    },
    {
      date: dateCreation,
      desc: 'sekeretaris perusahaan',
      id: 17,
      object: 'StrukturManajemen-sekretarisPerusahaan',
      object_title: 'Struktur Manajemen',
      title: 'Sekeretaris Perusahaan',
    },
    {
      date: dateCreation,
      desc: 'struktur organisasi',
      id: 18,
      object: 'StrukturManajemen-strukturOrganisasi',
      object_title: 'Struktur Manajemen',
      title: 'Struktur Organisasi',
    },
    {
      date: dateCreation,
      desc: 'kebijakan tanggung jawab',
      id: 19,
      object: 'TanggungJawabSosial-kebijakanTanggungJawab',
      object_title: 'Tanggung Jawab Sosial',
      title: 'Kebijakan Tanggung Jawab',
    },
    {
      date: dateCreation,
      desc: 'pelaksanaan tanggung jawab',
      id: 20,
      object: 'TanggungJawabSosial-pelaksanaanTanggungJawab',
      object_title: 'Tanggung Jawab Sosial',
      title: 'Pelaksanaan Tanggung Jawab',
    },
    {
      date: dateCreation,
      desc: 'tentang tata kelola perusahaan',
      id: 21,
      object: 'TataKelolaPerusahaan-TentangTataKelolaPerusahaan',
      object_title: 'Tata Kelola Perusahaan',
      title: 'Tentang Tata Kelola Perusahaan',
    },
  ]

  const loadDataSearch = async function () {
    let { data } = await GlobalSearchingAPI(
      `?language=${localStorage.getItem(
        'i18nextLng'
      )}&query=${search}&page=${page}`
    )

    if (search.trim().length === 0) {
      data.data = []
      data.success = true
      data.length = 0
      data.total = 0
    }

    if (search.toLowerCase().includes('riwayat')) {
      data.data.unshift(dataSearch[0])
    }
    if (
      search.toLowerCase().includes('visi') ||
      search.toLowerCase().includes('misi')
    ) {
      data.data.unshift(dataSearch[1])
    }
    if (
      search.toLowerCase().includes('segmen') ||
      search.toLowerCase().includes('bisnis')
    ) {
      data.data.unshift(dataSearch[2])
    }
    if (search.toLowerCase().includes('anak')) {
      data.data.unshift(dataSearch[3])
    }
    if (search.toLowerCase().includes('budaya')) {
      data.data.unshift(dataSearch[4])
    }
    if (search.toLowerCase().includes('penghargaan')) {
      data.data.unshift(dataSearch[5])
    }
    if (
      search.toLowerCase().includes('bank') ||
      search.toLowerCase().includes('koresponden')
    ) {
      data.data.unshift(dataSearch[6])
    }
    if (
      search.toLowerCase().includes('lembaga') ||
      search.toLowerCase().includes('profesi')
    ) {
      data.data.unshift(dataSearch[7])
    }
    if (
      search.toLowerCase().includes('hubungi') ||
      search.toLowerCase().includes('kami')
    ) {
      data.data.unshift(dataSearch[8])
    }
    if (search.toLowerCase().includes('piagam')) {
      data.data.unshift(dataSearch[9])
    }
    if (search.toLowerCase().includes('pedoman')) {
      data.data.unshift(dataSearch[10])
    }
    if (
      search.toLowerCase().includes('laporan') ||
      search.toLowerCase().includes('tata') ||
      search.toLowerCase().includes('kelola')
    ) {
      data.data.unshift(dataSearch[11])
    }
    if (
      search.toLowerCase().includes('kode') ||
      search.toLowerCase().includes('etik')
    ) {
      data.data.unshift(dataSearch[12])
    }
    if (
      search.toLowerCase().includes('whistleblowing') ||
      search.toLowerCase().includes('system')
    ) {
      data.data.unshift(dataSearch[13])
    }
    if (
      search.toLowerCase().includes('komisaris') ||
      search.toLowerCase().includes('dewan')
    ) {
      data.data.unshift(dataSearch[14])
    }
    if (
      search.toLowerCase().includes('direksi') ||
      search.toLowerCase().includes('dewan')
    ) {
      data.data.unshift(dataSearch[15])
    }
    if (search.toLowerCase().includes('komite')) {
      data.data.unshift(dataSearch[16])
    }
    if (search.toLowerCase().includes('sekretaris')) {
      data.data.unshift(dataSearch[17])
    }
    if (
      search.toLowerCase().includes('struktur') ||
      search.toLowerCase().includes('organisasi')
    ) {
      data.data.unshift(dataSearch[18])
    }
    if (
      search.toLowerCase().includes('kebijakan') ||
      search.toLowerCase().includes('tanggung jawab')
    ) {
      data.data.unshift(dataSearch[19])
    }
    if (
      search.toLowerCase().includes('pelaksanaan') ||
      search.toLowerCase().includes('tanggung jawab')
    ) {
      data.data.unshift(dataSearch[20])
    }
    if (
      search.toLowerCase().includes('tentang') ||
      search.toLowerCase().includes('tata') ||
      search.toLowerCase().includes('kelola') ||
      search.toLowerCase().includes('perusahaan')
    ) {
      data.data.unshift(dataSearch[21])
    }

    setdata(data.data)
    setisLoading(false)
    setTotal(data.total)
  }

  const createPaginationSearch = () => {
    return {
      totalItems: total,
      currentPage: +page,
      keySearch: search,
    }
  }

  const doSearch = async () => {
    setStaticSearch(search)
    setIsSearch(true)
    loadDataSearch()
  }
  return (
    <>
      <div className="search-page">
        <div className="search-page-banner">
          <img className="banner" src={BannerSearchBackground} alt="banner" />
          <div className="search-page-content-wrapper p-3">
            <div className="p-0 order-lg-1 mb-lg-0 mx-0 px-lg-3 mx-lg-3">
              <div className="title-page p-2 ps-lg-5">Cari kebutuhan Anda</div>
            </div>
          </div>
        </div>
        <div className="search-page-section-wrapper">
          <div className="search-page-button-wrapper">
            <InputWithButton2
              icon={IconSearch}
              placeholder={t('masukan_kata_kunci')}
              buttonLabel={t('search')}
              value={search}
              setValue={setSearch}
              doFunction={doSearch}
              doReset="true"
              doResetType="/search"
            />
          </div>
        </div>
        <div className="search-page-section">
          <div
            className={`header-wrapper ${
              isSearch || query.get('q') !== null ? '' : 'd-none'
            } `}
          >
            <h1 className="title">{t('hasil_pencarian')}</h1>
            <span className="description">
              {t('menampilkan_hasil_untuk_kata_kunci')} <b>'{staticSearch}'</b>
            </span>
          </div>
          <div className={`${isSearch ? 'd-block' : 'd-none'} `}>
            {data.length <= 0 ? t('tidak_ditemukan') : ''}
          </div>
          {isLoading ? [] : <ListSearch data={data} buttonTitle={t('more')} />}
          <div
            className={`pagination-wrapper ${
              (isSearch && data.length > 0) || query.get('q') !== null
                ? ''
                : 'd-none'
            } `}
          >
            <nav
              className="pagination-box d-flex align-items-center justify-content-center"
              aria-label="News Pagination"
            >
              <ul className="pagination">
                <PaginationSearch {...createPaginationSearch()} />
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <FooterSection currentPage={t('search')} />
    </>
  )
}

export default Search
